module.exports = __webpack_public_path__ + "img/刘涛.60ead754.jpg";